/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable import/extensions */
import Head from "next/head";
import PropTypes from "prop-types";
import NavbarHeader from "@fdn/navbar_header";
// import SubNav from "@fdn/sub_nav";
// import Cookies from "js-cookie";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import CategoryMenu from "@fdn/category_menu";
import ButtonCampaign from "@fdn/button_campaign";
import NewFooter from "@fdn/new_footer";
import AlloExploreModal from "Components/modal_allo/allo_explore_modal";
import Env from "Consts/env";
import Vars from "Consts/vars";
import AlloMain from "@fdn/allo_profile_migration";
import Cookies from "js-cookie";
import AlloSectionProfilePopup from "Components/allo/AlloProfilePopupSection";
import {
	ScrollToUp, Rupiah,
} from "../helpers/utils";

import { loadSearchProducts } from "@/Store/SearchProducts/lib/actions";
import { loadSearchBrands } from "@/Store/SearchBrands/lib/actions";
import { loadSearchUsers } from "@/Store/SearchUsers/lib/actions";
import { loadSearchArticles } from "@/Store/SearchArticles/lib/actions";
import { loadWallet } from "@/Store/allo_wallet/lib/actions";
import { loadCompleteProfile } from "@/Store/CompleteProfile/lib/actions";

const baseAppName = "Female Daily List Ticket";
let appName = "";

const Layout = ({	...props }) => {

	const prop = props;

	if (typeof prop.title !== "undefined") {

		appName = `${baseAppName} - ${prop.title}`;

	}

	const isMobile = prop.isMobile || false;

	useCallback(() => {

		ScrollToUp();

	}, []);

	const dispatch = useDispatch();
	const getData = useSelector((state) => state);

	const [TotalNotifReviews, setTotalNotifReviews] = useState(0);
	const [TotalNotifTalks, setTotalNotifTalks] = useState(0);
	const [products, setProductsResult] = useState([]);
	const [brands, setBrandsResult] = useState([]);
	const [users, setUsersResult] = useState([]);
	const [articles, setArticlesResult] = useState([]);

	const [searchText, setSearchText] = useState("");
	const [isShowSearch, setShowSearch] = useState(false);
	const [isShowSearchResult, setShowSearchResult] = useState(false);
	const [isShowSearchInput, setShowSearchInput] = useState(false);

	// category tab state
	const [isShowCategoryMenu, setIsShowCategoryMenu] = useState(false);
	const [isCollapseBrandOpen, setIsCollapseBrandOpen] = useState(false);
	const [isCategorySidebarOpen, setIsCategorySidebarOpen] = useState(false);
	const [isShowSidebar, setIsShowSidebar] = useState(false);
	const [activeTab, setActiveTab] = useState("skincare");
	const [activeChar, setActiveChar] = useState("a");
	const [activeCollapseBrand, setActiveCollapseBrand] = useState("");

	const [isArticlesResultLoading, setArticlesResultLoading] = useState(false);
	const [isProductsResultLoading, setProductsResultLoading] = useState(false);
	const [isBrandsResultLoading, setBrandsResultLoading] = useState(false);
	const [isUsersResultLoading, setUsersResultLoading] = useState(false);

	const [isHidetopMenu, setToggleTopMenu] = useState(false);
	const [isShowModalAdd, setIsShowModalAdd] = useState(false);

	const [isShowFloatingButton, setIsShowFloatingButton] = useState(false);

	const updateSearchText = (e) => {

		setSearchText(e.target.value);

		if (

			(searchText.length >= 3 && !isMobile) || (searchText.length > 0 && isMobile)

		) {

			setShowSearch(true);
			setArticlesResultLoading(true);
			setProductsResultLoading(true);
			setBrandsResultLoading(true);
			setShowSearchResult(true);

		} else {

			setShowSearch(false);
			setArticlesResultLoading(false);
			setProductsResultLoading(false);
			setBrandsResultLoading(false);
			setShowSearchResult(false);

		}

	};

	const submitSearch = (e) => {

		e.preventDefault();
		window.location.href = `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/search?q=${encodeURIComponent(searchText)}&tab=all`;

	};

	const showSearch = () => {

		if (!isMobile) {

			setShowSearch(true);

		} else {

			setShowSearchInput(true);

		}

	};

	const handleCategoryList = () => {

		setIsShowCategoryMenu((state) => !state);

	};

	const handleTab = (param) => {

		setActiveTab(param);
		setActiveChar("");

	};

	const handleChar = (param) => {

		setActiveChar(param);

	};

	const handleCloseCategoryMobile = () => {

		setIsShowCategoryMenu(false);
		setIsCategorySidebarOpen(false);

	};

	const handleCollapseBrand = (param) => {

		setActiveCollapseBrand(param);
		setIsCollapseBrandOpen((state) => !state);

	};

	const handleToggleSidebar = () => {

		setIsShowSidebar((state) => !state);

	};

	const handleBackSidebar = () => {

		setIsCategorySidebarOpen(false);
		setIsShowCategoryMenu(false);
		setIsShowSidebar(true);

	};

	const handleCategoryListSidebar = () => {

		setIsShowCategoryMenu(true);
		setIsShowSidebar(false);
		setIsCategorySidebarOpen(true);

	};

	const handleModalAdd = () => {

		setIsShowModalAdd(true);

	};

	const handleCloseModalAdd = () => {

		setIsShowModalAdd(false);

	};

	const handleCloseFloatingButton = () => {

		setIsShowFloatingButton(false);

	};

	useEffect(() => {

		let interval;
		if (
			(searchText.length >= 3 && !isMobile)
			|| (searchText.length > 0 && isMobile)
		) {

			interval = setTimeout(() => {

				// set article search result
				dispatch(
					loadSearchArticles({
						payload: {
							headers: Env.HEADERS,
							is_server: true,
							keyword: searchText,
						},
					}),
				);

				// set product search result
				dispatch(
					loadSearchProducts({
						payload: {
							headers: Env.HEADERS,
							is_server: true,
							keyword: searchText,
						},
					}),
				);

				// set brand search result
				dispatch(
					loadSearchBrands({
						payload: {
							headers: Env.HEADERS,
							is_server: true,
							keyword: searchText,
						},
					}),
				);

				// set user search result
				dispatch(
					loadSearchUsers({
						payload: {
							headers: Env.HEADERS,
							is_server: true,
							keyword: searchText,
						},
					}),
				);

			}, 1000);

		} else {

			setProductsResult([]);
			setBrandsResult([]);
			setUsersResult([]);

		}

		return () => clearTimeout(interval);

	}, [searchText]);

	useEffect(() => {

		if (Array.isArray(getData.storeSearchProducts.data.data)) {

			if (getData.storeSearchProducts.data.data.length > 0) {

				setProductsResult(getData.storeSearchProducts.data.data);

			} else {

				setProductsResult([]);

			}

		}

		setProductsResultLoading(false);

	}, [getData.storeSearchProducts]);

	useEffect(() => {

		if (Array.isArray(getData.storeSearchBrands.data.data)) {

			if (getData.storeSearchBrands.data.data.length > 0) {

				setBrandsResult(getData.storeSearchBrands.data.data);

			} else {

				setBrandsResult([]);

			}

		}

		setBrandsResultLoading(false);

	}, [getData.storeSearchBrands]);

	useEffect(() => {

		if (Array.isArray(getData.storeSearchArticles.data.data)) {

			if (getData.storeSearchArticles.data.data.length > 0) {

				setArticlesResult(getData.storeSearchArticles.data.data);

			} else {

				setArticlesResult([]);

			}

		}

		setArticlesResultLoading(false);

	}, [getData.storeSearchArticles]);

	useEffect(() => {

		if (Array.isArray(getData.storeSearchUsers.data.data)) {

			if (getData.storeSearchUsers.data.data.length > 0) {

				setUsersResult(getData.storeSearchUsers.data.data);

			} else {

				setUsersResult([]);

			}

		}

		setUsersResultLoading(false);

	}, [getData.storeSearchUsers]);

	const handleNotif = () => {

		// const auth = Cookies.get("token");

		// if (auth) {

		// 	Fetching({
		// 		method: "POST",
		// 		url: "getNotificationReviews",
		// 		data: {
		// 			authorization: auth,
		// 		},
		// 	})
		// 		.then((res) => {

		// 			if (res.data.meta.code === 200) {

		// 				setTotalNotifReviews(res.data.data);

		// 			} else {

		// 				console.log(`${res.data.meta.msg}`);

		// 			}

		// 		})
		// 		.catch((err) => {

		// 			console.log(`Error get data: ${err}`);

		// 		});

		// 	Fetching({
		// 		method: "POST",
		// 		url: "getNotificationTalks",
		// 		data: {
		// 			authorization: auth,
		// 		},
		// 	})
		// 		.then((res) => {

		// 			if (res.data.meta.code === 200) {

		// 				setTotalNotifTalks(res.data.payload.data.total_new_notification);

		// 			} else {

		// 				console.log(`${res.data.meta.msg}`);

		// 			}

		// 		})
		// 		.catch((err) => {

		// 			console.log(`Error get data: ${err}`);

		// 		});

		// }

	};

	const [IsShowAlloPopup, SetShowAlloPopup] = useState(false);
	useEffect(() => {

		handleNotif();

		if (!isMobile) {

			window.addEventListener("scroll", () => {

				if (document.documentElement.scrollTop > 84) {

					setToggleTopMenu(true);

				} else {

					setToggleTopMenu(false);

				}

			});

		}

		if (!Cookies.get("alloPopup") && process.env.NEXT_PUBLIC_ALLO_STATUS === "ON") {

			SetShowAlloPopup(true);

		}

	}, []);

	const [isShowAlloExplorePopup, setShowAlloExplorePopup] = useState(false);

	const handlePopupAlloExplore = () => {

		if (isMobile) {

			setIsShowSidebar(false);

		}
		setShowAlloExplorePopup(true);

	};

	useEffect(() => {

		if (props.self?.data?.id) {

			dispatch(
				loadCompleteProfile({
					payload: {
						headers: Env.HEADERS_WALLET,
						Authorization: Cookies.get("token"),
					},
				}),
			);

		}

	}, [props.self]);

	const [isUserVerified, setUserVerified] = useState(null);
	const checkUserVerified = () => {

		try {

			const dataProfile = getData.storeCompleteProfile?.data?.data;

			const completeProfileData = process.env.NEXT_PUBLIC_ALLO_STATUS === "ON" ? dataProfile : dataProfile?.account_status;

			if (process.env.NEXT_PUBLIC_ALLO_STATUS === "ON") {

				const isAlloComplete = Array.isArray(completeProfileData) ? completeProfileData.filter((completing) => completing?.description === "complete_account_allo" && completing?.status === true) : false;
				return completeProfileData?.is_profile_complete === true || (Array.isArray(isAlloComplete) && isAlloComplete?.length);

			} else {

				const nonAlloAccountStatus = Array.isArray(completeProfileData) ? completeProfileData?.filter((completion) => (completion?.description === "complete_verify_email" || completion?.description === "complete_verify_phone") && completion?.status === true) : [];
				return nonAlloAccountStatus?.length === 2;

			}

		} catch {

			return null;

		}

	};
	useEffect(() => {

		if (getData.storeCompleteProfile.status === "fetch_result") {

			setUserVerified(checkUserVerified());

		}

	}, [getData.storeCompleteProfile]);

	return (
		<div>

			<Head>
				<title>{appName}</title>
				<link rel="icon" href="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/logo/favicon.ico" />
				<meta charSet="utf-8" />
				<meta httpEquiv="X-UA-Compatible" content="IE=edge" />
				<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
				<link rel="apple-touch-icon-precomposed" sizes="144x144" href={`${`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/images/fdn_logo_144.png`}`} />
				<link rel="apple-touch-icon-precomposed" sizes="114x114" href={`${`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/images/fdn_logo_144.png`}`} />
				<link rel="apple-touch-icon-precomposed" sizes="72x72" href={`${`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/images/fdn_logo_72.png`}`} />
				<link rel="apple-touch-icon-precomposed" sizes="57x57" href={`${`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/images/fdn_logo_57.png`}`} />
				<link rel="stylesheet" href={`${`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/ticket/styles/font_google.css`}`} />
				<link rel="stylesheet" href="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/style/bundle.css" />
				<link rel="stylesheet" type="text/css" href={`${`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/ticket/styles/icomoon/styles.css`}`} />
				<link rel="stylesheet" type="text/css" href={`${`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/ticket/styles/new_icomoon/styles.css`}`} />
				<link rel="stylesheet" type="text/css" href={`${`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/ticket/styles/fontastic/styles.css`}`} />
				<link rel="stylesheet" href="https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/style/bundle.css" />
				{process.env.NEXT_PUBLIC_NODE_ENV === "production" ? (
					/* ALEXA */
					<script
						async
						custom-element="amp-analytics"
						src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"
					/>
				) : null}

			</Head>

			{process.env.NEXT_PUBLIC_NODE_ENV === "production" ? (
				<amp-analytics
					type="alexametrics"
					dangerouslySetInnerHTML={{
						__html: `
			<script type="application/json"> {"vars": { "atrk_acct": "5TYNs1O7kI20L7", "domain": "review.femaledaily.com" }}</script>`,
					}}
				/>
			) : ("")}

			<div dangerouslySetInnerHTML={{ __html: prop.adsHead }} />

			<div dangerouslySetInnerHTML={{ __html: prop.adsFoot }} />

			{
				isShowFloatingButton && (
					<div className="floating-btn-wrapper">
						<ButtonCampaign
							is_mobile={isMobile}
							element_id="floating-btn-ticket"
							campaign_link="https://docs.google.com/forms/d/e/1FAIpQLSfKsGcVhi17ui7Bz1mubLzRAkAYgR2Qsq3oj9niSwCzeF1X4g/viewform?usp=sharing"
							button_image="https://image.femaledaily.com/banner/MxB-2022-visitor-btn.png"
							close_bg_color="#AF8DFE"
							close_arrow_color="#FFFFFF"
							show_campaign={handleCloseFloatingButton}
						/>

						<style>
							{`
								.close-campaign {
									cursor: pointer;
								}
							`}
						</style>
					</div>
				)
			}

			<NavbarHeader
				is_mobile={isMobile}
				nav_width="1200px"
				type="monochrome"
				self={prop.self?.data}
				nav_position="fixed"
				menu={Vars.MENU}
				main_link={process.env.NEXT_PUBLIC_ROOT_DOMAIN}
				home_link={process.env.NEXT_PUBLIC_ROOT_HOME}
				reviews_link={process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}
				talk_link={process.env.NEXT_PUBLIC_TALK_DOMAIN}
				sso_link={process.env.NEXT_PUBLIC_SSO_DOMAIN}
				sidebar_config={Vars.CONFIG_SIDEBAR}
				profile_link={`${process.env.NEXT_PUBLIC_SSO_DOMAIN}/user/${prop.self?.data?.username}`}
				logo_id="id_logo_editorial"
				search_input_id="id_search_input_field_editorial"
				button_login_id="id_loginsignup_editorial"
				button_cart_id="id_carteditorial"
				button_notif_id="id_notifeditorial"
				total_unread_notif={parseInt(TotalNotifReviews, 10) + parseInt(TotalNotifTalks, 10)}
				submit_search={submitSearch}
				search_text={searchText}
				update_search_text={updateSearchText}
				toggle_sidebar={handleToggleSidebar}
				close_search_suggest={() => {

					setSearchText("");
					setShowSearch(false);

				}}
				is_article_loading={isArticlesResultLoading}
				is_product_loading={isProductsResultLoading}
				is_user_loading={isUsersResultLoading}
				is_brand_loading={isBrandsResultLoading}
				is_show_search_suggest={isShowSearch}
				is_show_search_result={isShowSearchResult}
				is_show_search={isShowSearchInput}
				is_show_sidebar={isShowSidebar}
				// is_user_verified={isUserVerified}
				show_search={showSearch}
				products={products}
				brands={brands}
				users={users}
				articles={articles}
				hide_search={() => {

					setShowSearch(false);
					setShowSearchInput(false);

				}}
				is_hide_top_menu={isHidetopMenu}
				handle_category_list_sidebar={handleCategoryListSidebar}
				onBlurInput={() => setTimeout(() => setShowSearch(false), 1000)}
				onClickLoginSignup={() => {

					if (process.env.NEXT_PUBLIC_ALLO_STATUS === "ON") {

						if (isMobile) {

							SetShowAlloPopup(!IsShowAlloPopup);
							setIsShowSidebar(false);

						} else {

							SetShowAlloPopup(!IsShowAlloPopup);

						}

					} else {

						window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}?url=${typeof window !== "undefined" ? window.location.href : process.env.NEXT_PUBLIC_ROOT_DOMAIN + process.env.NEXT_PUBLIC_PREFIX}`;

					}

				}}
				profilePopupCustomElement={
					props.self?.data?.mpc_id && process.env.NEXT_PUBLIC_ALLO_STATUS === "ON"
						? (
							<AlloSectionProfilePopup
								onClickAlloCoupon={handlePopupAlloExplore}
							/>
						)
						: null
				}
				handleAlloExplorer={handlePopupAlloExplore}
				SisterSites={
					[
						{
							name: "Mommies Daily",
							value: "md",
							pathname: process.env.NEXT_PUBLIC_MD_DOMAIN,
							query: "",
							visible: true,
							new: false,
						},
						{
							name: "Female Daily Studio",
							value: "bs",
							pathname: process.env.NEXT_PUBLIC_ECM_DOMAIN,
							query: "",
							visible: true,
							new: false,
						},
						{
							name: "Girls Beyond",
							value: "gb",
							pathname: process.env.NEXT_PUBLIC_GB_DOMAIN,
							query: "",
							visible: true,
							new: false,
						},
					]
				}
				// eventImage={isMobile ? "https://image.femaledaily.com/images/BOBA2022_ribbon+banner_414x30.jpg" : "https://image.femaledaily.com/images/BOBA2022_ribbon+banner_1440x30.jpg"}
				// eventURL={`${process.env.NEXT_PUBLIC_AWARDS_DOMAIN}?&utm_source=web&utm_medium=ribbon_fd&utm_campaign=boba2022`}
				is_user_verified={isUserVerified}
			/>

			<style>
				{`
					.sidebar .profile-option:nth-child(1){
						display: none;
					}

					.btn-login {
						box-sizing: border-box;
					}
					.navbar-header-placeholder{
						height: ${isMobile ? "62px" : "117px"};
					}
					img {
						max-width: 100%;
						max-height: 100%;
						width: auto;
						height: auto;
					}

					.navbar-header {
						background-color: #FFF;
					}

					.navbar-inner-content-wrapper {
						max-width: 1200px;
					}

					.mega-menu-wrapper {
						max-width: 1200px;
						margin: 0 auto;
						display: flex;
						justify-content: center;
					}

					.search-input-field input {
						max-width: calc(100% - 32px);
					}

					.product-result { 
						box-sizing: border-box; 
					}

					.brand-card {
						flex-wrap: nowrap;
					}

					.sub-menu-title a {
						text-transform: uppercase;
					}

					.menu-popup {
						max-width: calc(100% - 48px);
					}

					img.sub-menu-item {
						max-width: 100%;
					}

					.left-category-list {
						width: 247px !important;
						// margin-top: 0 !important;
						// height: fit-content !important;
						// padding: 22px 32px !important;
					}

					.top-frame {
						position: fixed;
						top: ${isHidetopMenu ? "123px" : "164px"};
						left: 0;
						right: 0;
						z-index: 2;
						display: flex;
						justify-content: center;
					}

					.fdn-modal {
						animation: none !important;
					}

            .navbar-header .mega-menu {
              padding-bottom: 0;
            }

            .mega-menu-wrapper {
              width: 100%;
              max-width: 100%;
              margin-top: 12px;
              display: unset;
              justify-content: unset;
            }

            .navbar-header .search-popup-content {
              max-width: calc(100% - 32px);
            }

            .menu-popup {
              max-width: unset;
            }

            .menu-popup-title {
              justify-content: space-between;
            }
          }

					.profile-popup {
						width: 100%;
					}

					.top-menu .menus a {
						cursor: pointer;
					}

        `}
			</style>
			<style jsx global>
				{`
					a {
						text-decoration: none;
					}

					body {
						margin: 0px;
						max-width: 100%;
						overflow-x: hidden;
					}
					.container {
						width: ${isMobile ? "calc(100% - 16px - 16px)" : "100%"};
						max-width: calc(1200px - 24px - 24px);
						margin: auto;
					}
				`}
			</style>

			{

				IsShowAlloPopup
					&& (
						<>
							<AlloMain
								isMobile={isMobile}
								hostDomain={`.femaledaily.${["canary", "production"].includes(process.env.NEXT_PUBLIC_NODE_ENV) ? "com" : "net"}`}
								ssoDomain={process.env.NEXT_PUBLIC_SSO_DOMAIN}
								// errorOffsetTop={navHeight + "px"}
								closeElement={() => SetShowAlloPopup(false)}
								query={[]}
								onClickMigrateAccount={() => {

									const pageReferer = window.location.href;
									window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}?url=${pageReferer}`;

								}}
								onClickLoginRegister={() => {

									const pageReferer = window.location.href;
									window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}?url=${pageReferer}`;

								}}
								helpUrl={`${process.env.NEXT_PUBLIC_ROOT_HOME}/help?tab=account`}
							/>
							<style>
								{`
									.allo-form .welcome-image {
										max-width: unset;
									}
								`}
							</style>
						</>
					)

			}

			<div className="main-content">
				{prop.children}
				<style>
					{`
						.ads-bottomframe,
						.ads-stickystaticbanner {
							width: 100%;
							position: fixed;
							bottom: -4px;
							display: flex;
							justify-content: center;
							z-index:2
						}
						.ads-bottomframe {
							bottom: -4px;
						}
					`}
				</style>
			</div>
			{/* {process.env.NEXT_PUBLIC_NODE_ENV === "production" ? (
				<script dangerouslySetInnerHTML={setGoogleAnalyticsNoscriptGaHost()} />
			) : (
				""
			)}

			{process.env.NEXT_PUBLIC_NODE_ENV === "production" ? (
				<noscript dangerouslySetInnerHTML={comScoreNoScript()} />
			) : (
				""
			)}

			{process.env.NEXT_PUBLIC_NODE_ENV === "production" ? (
				<noscript dangerouslySetInnerHTML={setGTMNoScript()} />
			) : (
				""
			)}

			{process.env.NEXT_PUBLIC_NODE_ENV === "production" ? (
				<noscript dangerouslySetInnerHTML={setFBPixelNoScript()} />
			) : (
				""
			)} */}

			<AlloExploreModal
				isMobile={isMobile}
				isShow={isShowAlloExplorePopup}
				onClick={() => setShowAlloExplorePopup(false)}
			/>

			<NewFooter
				is_mobile={isMobile}
				handleScrollUp={ScrollToUp}
				footerMenu={[
					{
						title: "About Us",
						target: "_self",
						href: `${process.env.NEXT_PUBLIC_ROOT_HOME}/about`,
						id: "id_aboutus",
					},
					{
						title: "Terms & Conditions",
						target: "_self",
						href: `${process.env.NEXT_PUBLIC_ROOT_HOME}/terms-and-conditions`,
						id: "id_tc",
					},
					{
						title: "Awards",
						target: "_self",
						href: `${process.env.NEXT_PUBLIC_AWARDS_DOMAIN}`,
						id: "id_awards",
					},
					{
						title: "Feedback",
						target: "_self",
						href: `${process.env.NEXT_PUBLIC_ROOT_HOME}/feedback`,
						id: "id_feedback",
					},
					{
						title: "Privacy Policy",
						target: "_self",
						href: `${process.env.NEXT_PUBLIC_ROOT_HOME}/privacy-policy`,
						id: "id_privacy_policy",
					},
					{
						title: "Newsletter",
						target: "_self",
						href: `${process.env.NEXT_PUBLIC_MD_DOMAIN}`,
						id: "id_newsletter",
					},
					{
						title: "Contact",
						target: "_self",
						href: `${process.env.NEXT_PUBLIC_MD_DOMAIN}/contact`,
						id: "id_contact",
					},
					{
						title: "Help",
						target: "_self",
						href: `${process.env.NEXT_PUBLIC_ROOT_HOME}/help`,
						id: "id_help",
					},
					{
						title: "Media Kit",
						target: "_self",
						href: `${process.env.NEXT_PUBLIC_ROOT_HOME}/media-kit`,
						id: "id_media_kit",
					},
				]}
				footerSite={[
					{
						alt: "logo-fd",
						src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/logo-femaledaily.svg",
						url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}?ref=fromglobalfooter`,
						height: 28,
					},
					{
						alt: "logo-md",
						src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/logo-md.svg",
						url: `${process.env.NEXT_PUBLIC_MD_DOMAIN}?ref=fromglobalfooter`,
						height: 28,
					},
					{
						alt: "logo-fds",
						src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/logo-fds.svg",
						url: `${process.env.NEXT_PUBLIC_ECM_DOMAIN}?ref=fromglobalfooter`,
						height: 40,
					},
					{
						alt: "logo-gb",
						src: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/logo-gb.svg",
						url: `${process.env.NEXT_PUBLIC_GB_DOMAIN}?ref=fromglobalfooter`,
						height: 36,
					},
				]}
			/>

		</div>
	);

};

export default Layout;

Layout.propTypes = {
	children: PropTypes.node.isRequired,
	title: PropTypes.node.isRequired,
	// ismobile: PropTypes.bool,
};
